import React, { useState } from "react";
import './WebDesign.css';
import branding from './assets/Branding.avif';
import brandingprocess from './assets/brandingprocess.avif';
import brandingoffer from './assets/brandingoffer.jpg';

const Branding = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Branding</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Branding</span>
                        </p>
                    </div>
                </div>
            </section>

            <div className="company-section py-5">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Branding & Identity – Crafting a Unique Brand That Resonates</h2>
                            <p>Your brand identity is much more than just a logo – it’s the story, values, and emotions that connect your business with your audience. We help you establish a strong, consistent brand presence through comprehensive branding strategies that encompass logo design, messaging, and visual identity. Our goal is to help you stand out and build trust with your customers.</p>
                            <h3>Why Branding & Identity Matter</h3>
                            <p>A strong brand identity sets you apart from the competition and makes your business memorable. It establishes credibility, builds customer loyalty, and influences purchasing decisions. A well-defined brand identity ensures consistency across all touchpoints, reinforcing your company’s values and mission.</p>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={branding} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={brandingprocess} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>Our Branding Process</h3>                                
                                <ol>
                                    <li><b>Discovery & Research:</b> Understanding your brand, target audience, and market position.</li>
                                    <li><b>Logo & Visual Identity Design:</b> Crafting a unique logo and brand elements that reflect your vision.</li>
                                    <li><b>Brand Messaging & Strategy:</b> Defining your brand’s voice, positioning, and communication strategy.</li>
                                    <li><b>Implementation & Consistency:</b> Ensuring your brand identity is effectively applied across all platforms.</li>
                                </ol>
                            </div>
                        </div>                        
                    </div>

                    <div className="row">                        
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>What We Offer</h3>                                
                                <ol>
                                    <li><b>Logo Design and Visual Identity Creation:</b> Designing a cohesive and impactful brand aesthetic.</li>
                                    <li><b>Brand Messaging, Positioning, and Strategy:</b> Developing a strong and compelling brand story.</li>
                                    <li><b>Brand Guidelines to Ensure Consistency:</b> Providing a framework for maintaining uniform branding.</li>
                                    <li><b>Marketing Collateral and Business Stationery:</b> Creating branded materials that leave a lasting impression.</li>
                                </ol>
                            </div>
                        </div>  
                        <div className="col-md-6 side-images py-5">
                            <img src={brandingoffer} alt="Mobile Optimization" className="mt-3" />
                        </div>                      
                    </div>

                    <section className="hero-section text-column mt-5">
                        <p>A powerful brand identity is the foundation of long-term business success. At Dot Localhost, we help businesses define and express their unique identity through strategic branding solutions. Let us craft a brand that resonates with your audience and drives meaningful connections.</p>
                    </section>

                </div>
            </div>

        </>
    );
};

export default Branding;